import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import styles from './styles.module.scss';

interface HeaderProps {
  logoUrl: string;
  onClickBack?: () => void;
}

const Header = ({ logoUrl, onClickBack }: HeaderProps) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        className={styles.header}
        sx={{
          bgcolor: '#FFFFFF',
          flex: 'auto',
          boxShadow: 'none',
          borderBottom: '1px solid #ECECEC',
        }}
      >
        <Toolbar>
          {onClickBack && (
            <IconButton size="large" edge="start" color="primary" aria-label="menu" sx={{ mr: 2 }} onClick={onClickBack}>
              <ChevronLeftIcon />
            </IconButton>
          )}
          {/* Merchant logo.
          logoUrl && (
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                margin: 'auto',
                width: '100%',
                maxHeight: 50,
                maxWidth: 300,
              }}
            >
              <img src={logoUrl} className={styles.logo} />
            </Box>
            ) */}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
